<template>
  <v-card>
    <v-card-title class="text-h5 align-center bb-1">
      <v-icon class="pr-2" color="warning">mdi-alert</v-icon>
      Swedish Export Validation Issues
      <v-spacer />
      <v-btn icon @click="onCancel">
        <v-icon color="primary">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-4">
      <v-alert type="warning" outlined>
        <div class="text-body-1">
          <strong
            >{{ validationErrors.length }} of
            {{ totalListings }} listings</strong
          >
          have validation issues and cannot be included in the Swedish export.
        </div>
      </v-alert>

      <div v-if="validListings > 0" class="text-body-1 mt-4 mb-4">
        <strong>{{ validListings }} listings</strong> passed validation and can
        be exported.
      </div>

      <v-expansion-panels v-if="validationErrors.length <= 10" class="mt-4">
        <v-expansion-panel
          v-for="(item, index) in validationErrors"
          :key="index"
        >
          <v-expansion-panel-header>
            <div>
              <strong>{{
                item.listing.nickname || `Listing ${item.listing.id}`
              }}</strong>
              <span class="text-caption ml-2"
                >({{ item.errors.length }} issues)</span
              >
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <v-list-item
                v-for="(error, errorIndex) in item.errors"
                :key="errorIndex"
              >
                <v-list-item-icon>
                  <v-icon small color="error">mdi-alert-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ error }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div v-else class="mt-4">
        <v-simple-table dense>
          <template #default>
            <thead>
              <tr>
                <th>Listing</th>
                <th>Issues</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in validationErrors.slice(0, 10)"
                :key="index"
              >
                <td>
                  {{ item.listing.nickname || `Listing ${item.listing.id}` }}
                </td>
                <td>
                  <ul class="pl-4 my-1">
                    <li
                      v-for="(error, errorIndex) in item.errors.slice(0, 3)"
                      :key="errorIndex"
                      class="text-caption"
                    >
                      {{ error }}
                    </li>
                    <li
                      v-if="item.errors.length > 3"
                      class="text-caption text--secondary"
                    >
                      ... and {{ item.errors.length - 3 }} more issues
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="validationErrors.length > 10">
                <td colspan="2" class="text-center">
                  <em
                    >... and {{ validationErrors.length - 10 }} more listings
                    with issues</em
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-space-around pa-4">
      <v-btn depressed @click="onCancel">Cancel Export</v-btn>
      <v-spacer />
      <v-btn v-if="validListings > 0" color="primary" @click="onProceed">
        Export {{ validListings }} Valid Listings
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'SwedishValidationErrorsModal',
  props: {
    validationErrors: {
      type: Array,
      required: true,
    },
    totalListings: {
      type: Number,
      required: true,
    },
    validListings: {
      type: Number,
      required: true,
    },
    onProceed: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style scoped></style>
